export class MyBuilkFeedListModel {
  itemList: Array<any>;
  pageNumber: number;
  pageSize: number;
  totalItemCount: number;
  totalPageCount: number;
}

export class MyBuilkFeedListQueryModel {
  textSearch: string;
  pageSize: number;
  pageNumber: number;
  countryCode: string;
  date?: Date;
  culture: string;
}
